import React from 'react';

export const Check = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="19"
    height="15"
    viewBox="0 0 19 15"
    fill={color || 'none'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 7.31348L6.65685 12.9703L17.9706 1.65662"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
